import {React, useState } from 'react';
import axios from 'axios';
import '../styles/auth.css';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import {ReactComponent as LoadingIcon} from '../images/loading_icon.svg';


function Login(props) {
    //styling on form inputs
    const [label_class, setlabel_class] = useState({
        email_label:"formLabel",
        password_label:"formLabel"
    })
    const inputClicked=(label)=>{
        setlabel_class({...label_class, [label] :"formLabel_focus"});
    }

    const history = useHistory();

    let [email,SetEmail] = useState("");
    let [password,SetPassword] = useState("");
    const [error, setError] = useState("");
    const [process,setProcess] = useState(false);
    
    function GuestLogin(e){
      e.preventDefault();
      email = "rk@gmail.com";
      password = "12345678";
       LoginHandler(e);
    }

    const LoginHandler = async (e) =>{
        setProcess(true);
        e.preventDefault();
        const config = {
            header: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*"
            },
          };

          try {
            const res = await axios.post('https://messenger-api-rohit.herokuapp.com/api/login', { email, password }, config);
            localStorage.setItem("authToken", res.data.access_token);
            props.login(true);
            setProcess(false);
            history.push('/');
          } catch (err) {
            setProcess(false);
            if (err.response) {
                      setError(err.response.data.message);
                      setTimeout(() => {
                              setError("");
                            }, 5000);
                    }
          }
}

    return (
        <div className="signnup_div_parent">
        <div className="signnup_div">
            
        <div className="form_heading_div">
                <h2 className="form_heading">Login</h2>
                {/* <button className="hide_form_btn" onClick={props.hidebtn}>&#x2715;</button> */}
                <Link to="/" className="hide_form_btn">&#x2715;</Link>
            </div>
            <p className="error">{error}</p>

            <form>
            <div className="signInUp_input">
            <label className={label_class.email_label}>Email</label>
            <input type="email" onClick={()=>inputClicked("email_label")} onChange={(e)=>SetEmail(e.target.value)} value={email} name="Email" placeholder="" autoComplete="on"/>
            </div>

            <div className="signInUp_input">
            <label className={label_class.password_label}>Password</label>
            <input type="password" onClick={()=>inputClicked("password_label")} onChange={(e)=>SetPassword(e.target.value)} value={password} name="password" placeholder="" autoComplete="off"/>
            </div>
        
            <div className="signup_btn_div">
              <button onClick={(e)=>LoginHandler(e)} className="signup_btn">{!process?"Login":<LoadingIcon className="loading" />}</button>
              <button style={{backgroundColor:""}} onClick={(e)=>GuestLogin(e)} className="signup_btn">Login as Guest</button>
              </div>
            </form>
            <p className="signup_have">New to MineChat? <Link to="/signup">Create account</Link></p>
        </div>
        </div>
    )
}

export default Login
